import API from "./index"

export const getUpcomingPerformances = () => API.get(`/upcoming`)
export const createUpcomingPerformance = (data) => API.post(`/upcoming`, data)
export const deleteUpcomingPerformance = (id) => API.delete(`/upcoming/${id}`)